import { render, staticRenderFns } from "./TableFiledsSettings.vue?vue&type=template&id=10f39cec"
import script from "./TableFiledsSettings.vue?vue&type=script&lang=js"
export * from "./TableFiledsSettings.vue?vue&type=script&lang=js"
import style0 from "./TableFiledsSettings.vue?vue&type=style&index=0&id=10f39cec&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10f39cec')) {
      api.createRecord('10f39cec', component.options)
    } else {
      api.reload('10f39cec', component.options)
    }
    module.hot.accept("./TableFiledsSettings.vue?vue&type=template&id=10f39cec", function () {
      api.rerender('10f39cec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/package/TableFiledsSettings.vue"
export default component.exports